import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IIndividualsProperties } from 'src/app/modules/interfaces/properties.interface';

export interface IIndividualPropertyState {
  check: boolean;
  estimatedValue: number;
  propertyFinanced: boolean;
  notes: string;
}

@Component({
  selector: 'app-forms-properties',
  templateUrl: './forms-properties.component.html',
  styleUrls: ['./forms-properties.component.scss'],
})
export class FormsPropertiesComponent implements OnInit {
  @Input() data: IIndividualsProperties;
  @Output() value: EventEmitter<IIndividualsProperties> =
    new EventEmitter<IIndividualsProperties>();

  dataLocal: IIndividualsProperties;
  
  estimatedValuePropertyKey = this.getKey();
  propertyFinancedTrueKey = this.getKey();
  propertyFinancedFalseKey = this.getKey();
  notesKey = this.getKey();
  
  constructor() {}

  ngOnInit(): void {
    this.dataLocal = { ...this.data };
  }

  getKey(): string {
    return 'componente_' + Math.random().toString(36).substring(7);
  }

  updateDataValue(value, property: string): void {
    this.dataLocal = {
      ...this.dataLocal,
      [property]: value,
    };
    this.value.emit(this.dataLocal);
  }
}
